import * as Yup from 'yup';

import { inPortcoOptions as defaultInPortcoOptions } from '../../../defaultFilters';

export const useInPortcoFilter = ({ setFilters }) => {
  const inPortcoOptions = defaultInPortcoOptions;

  const formSchema = Yup.object().shape({
    inPortco: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.mixed().required(),
    }),
  });

  const onSubmit = ({ inPortco }) => {
    setFilters({ inPortco });
  };

  return {
    formSchema,
    onSubmit,
    inPortcoOptions,
  };
};
